import { render } from "./WorksheetBuilder.vue?vue&type=template&id=48b464e4&scoped=true&ts=true"
import script from "./WorksheetBuilder.vue?vue&type=script&lang=ts"
export * from "./WorksheetBuilder.vue?vue&type=script&lang=ts"

import "./WorksheetBuilder.vue?vue&type=style&index=0&id=48b464e4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b464e4"]])

export default __exports__